<div
  class="autocomplete-dropdown"
  (clickOutside)="onClickedOutside()"
  delayClickOutsideInit="true"
  data-cy="autocomplete-dropdown"
  [ngClass]="{ flat: flat, 'full-width': isFullWidth }"
>
  @if (!hideSearch) {
  <form class="top" [formGroup]="autocompleteForm">
    <wm-front-input
      [placeholder]="placeholder || ''"
      (input)="handleQueryChanged($event)"
      formControlName="searchQuery"
      (fastDeleted)="queryChanged.emit('')"
      [isCustom]="false"
      type="text"
      [fastDelete]="true"
      [autofocus]="true"
      data-cy="password-field"
      #input
    >
    </wm-front-input>
  </form>
  } @if (filteredOptions$ | async; as filteredOptions) { @if
  (filteredOptions.length > 0) {
  <div class="bottom" #scrollRef>
    <wm-front-infinite-scroll-container
      (scrolled)="scrolled.emit()"
      [overridedOptions]="{ infiniteScrollContainer: scrollRef, throttle: 0 }"
    >
      <ul data-cy="autocomplete-list-option">
        @for (option of filteredOptions; track trackByFn($index, option)) {
        <ng-container data-cy="autocomplete-option">
          @if (option.children) {
          <ng-container
            [ngTemplateOutlet]="optionTitle"
            [ngTemplateOutletContext]="{ $implicit: option }"
          ></ng-container>
          } @if (!option.children) {
          <ng-container
            [ngTemplateOutlet]="optionCheckbox"
            [ngTemplateOutletContext]="{
              $implicit: option,
              isChildren: false
            }"
          ></ng-container>
          }
        </ng-container>
        } @if (loading) {
        <li class="option option-spinner">
          <mat-spinner [diameter]="28" [strokeWidth]="3"></mat-spinner>
        </li>
        }
      </ul>
    </wm-front-infinite-scroll-container>
  </div>
  } @else { @if (error) {
  <div class="bottom has-error">
    <mat-icon svgIcon="alert-md"></mat-icon>
    <p
      i18n="
        label for the error label in the autocomplete dropdown
        component@@autoCompleteDropdownErrorLabel"
    >
      Erreur serveur, affichage des données impossible
    </p>
  </div>
  } @if (loading) {
  <div class="bottom no-result-spinner">
    <mat-spinner [diameter]="28" [strokeWidth]="3"></mat-spinner>
  </div>
  } @if (!!emptySearchMessage &&
  !!autocompleteForm.controls['searchQuery'].value && !loading) {
  <div class="bottom">
    <ul data-cy="autocomplete-list-option">
      <li class="option unsucessfull-search" data-cy="empty-search-message">
        {{ emptySearchMessage }}
      </li>
    </ul>
  </div>
  } }
  <ng-template #optionTitle let-option>
    <li class="option group-label">
      <mat-checkbox
        class="checkbox accent"
        data-cy="autocomplete-option-checkbox"
        [ngModel]="option.checked"
        [indeterminate]="option.isIndeterminate"
        (ngModelChange)="pickParent(option)"
        [disabled]="option.disabled"
        ngDefaultControl
      >
        @if (option.entity?.icon) {
        <mat-icon [svgIcon]="option.entity?.icon ?? ''"></mat-icon>
        }
        <span
          [style.font-style]="option.style"
          [innerHTML]="
            option.label | highlightSearch: autocompleteForm.value.searchQuery
          "
        ></span>
      </mat-checkbox>
    </li>
    @for (child of option.children; track trackByFn($index, child)) {
    <ng-container data-cy="autocomplete-option">
      <ng-container
        [ngTemplateOutlet]="optionCheckbox"
        [ngTemplateOutletContext]="{ $implicit: child, isChildren: true }"
      ></ng-container>
    </ng-container>
    }
  </ng-template>
  <ng-template #optionCheckbox let-option let-isChildren="isChildren">
    <li class="option" [class.is-children]="isChildren">
      @if (!radioMode) {
      <mat-checkbox
        class="checkbox accent"
        data-cy="autocomplete-option-checkbox"
        [ngModel]="option.checked"
        (ngModelChange)="pickValue(option)"
        [disabled]="option.disabled"
        ngDefaultControl
      >
        @if (option.entity?.icon) {
        <mat-icon [svgIcon]="option.entity?.icon ?? ''"></mat-icon>
        }
        <span
          [style.font-style]="option.style"
          [innerHTML]="
            option.label | highlightSearch: autocompleteForm.value.searchQuery
          "
        ></span>
      </mat-checkbox>
      } @if (radioMode) {
      <mat-radio-button
        class="checkbox accent"
        data-cy="autocomplete-option-checkbox"
        [checked]="option.checked"
        [disabled]="option.disabled"
        [name]="option.value"
        (click)="pickValue(option)"
        ngDefaultControl
      >
        @if (option.entity?.icon) {
        <mat-icon [svgIcon]="option.entity?.icon ?? ''"></mat-icon>
        }
        <span
          [style.font-style]="option.style"
          [innerHTML]="
            option.label | highlightSearch: autocompleteForm.value.searchQuery
          "
          (click)="pickValue(option)"
        ></span>
      </mat-radio-button>
      } @if (option.entity?.hasIot) {
      <mat-icon svgIcon="iot-xs"></mat-icon>
      }
    </li>
  </ng-template>
  <div
    class="reset"
    [class.hide]="hideResetBtn"
    [class.disabled]="!selectedOptions.length && !activeResetBtn"
    (click)="resetSelectedOptions()"
  >
    <p
      i18n="
        Button label | label for the reset button in the autocomplete dropdown
        component@@autoCompleteDropdownResetActionButton"
    >
      Réinitialiser
    </p>
  </div>
  }
</div>
